import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { SCREENS } from 'src/constants/screens';
import MenuManagTabHeader from 'src/view/containers/Headers/containers/MenuManagTabHeader/MenuManagTabHeader';
import ScreenHeader from 'src/view/containers/Headers/containers/ScreenHeader/ScreenHeader';
import { menuManagementNavigation } from 'src/view/screens/MenuManagementScreen/constants/menuManagement';
import MenuGroupsList from 'src/view/screens/MenuManagementScreen/screens/MenuGroupsScreen/containers/MenuGroupsList/MenuGroupsList';
import menuGroupsStore from 'src/view/screens/MenuManagementScreen/screens/MenuGroupsScreen/store/menuGroupsStore';

const MenuGroupsScreen = observer((): JSX.Element => {
  useEffect(() => {
    return () => menuGroupsStore.clearFilters();
  }, []);

  const setSearch = (search: string) => {
    menuGroupsStore.setFilters({ search });
  };

  return (
    <>
      <ScreenHeader title="txt_menu" options={menuManagementNavigation()} />
      <MenuManagTabHeader
        isShowImproveMenu
        createPath={SCREENS.MENU_GROUPS_CREATE()}
        search={menuGroupsStore.filters.search}
        loading={menuGroupsStore.isLoading}
        createButtonTitle="create_menu_group"
        foundItemsInSystem={!menuGroupsStore.noMenuGroupsFound}
        setSearch={setSearch}
      />
      <MenuGroupsList />
    </>
  );
});

export default MenuGroupsScreen;
